import { Plus as PlusIcon } from "lucide-react";
import * as React from "react";

import { Popover, RobotoButton } from "@/shared/foundation/primitives";

import { CreateDevice } from "./CreateDevice";

/**
 * "New Device" action for the devices page. Opens the create-device form in a
 * popover anchored to the button; the form closes it on a successful create.
 */
export function CreateDeviceButton() {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Popover.Trigger
        render={
          <RobotoButton
            variant="primary"
            icon={<PlusIcon aria-hidden="true" />}
          >
            New Device
          </RobotoButton>
        }
      />
      <Popover.Content align="end" aria-label="Create device">
        <CreateDevice close={() => setOpen(false)} />
      </Popover.Content>
    </Popover>
  );
}
